<div class="formgrid grid">
  <div class="field col mb-0">
    <label class="mb-0" *ngIf="showLabel"> {{ label }} </label>

    <div class="block md:hidden">
      <span class="p-fluid">
        <p-multiSelect
          [options]="locations"
          [(ngModel)]="selectedLocations"
          optionLabel="name"
          defaultLabel="Select Location"
          (click)="firstLoad()"
          display="chip"
          [disabled]="searching"
        >
          <ng-template pTemplate="footer">
            <button
              *ngIf="!loadedAll"
              pButton
              [disabled]="this.loadingNextPage"
              label="Load More"
              class="p-button-text"
              (click)="loadMore()"
            ></button>
          </ng-template>
        </p-multiSelect>
      </span>
    </div>
    <div class="hidden md:block">
      <span class="p-fluid">
        <p-chips
          (click)="toggleOverlay($event)"
          [(ngModel)]="selectedLocations"
          field="name"
          [placeholder]="placeHolderText"
          [allowDuplicate]="false"
          (onRemove)="this.locationSelectedChange.emit(this.selectedLocations)"
          (onAdd)="this.locationSelectedChange.emit(this.selectedLocations)"
          class="col px-0"
          [disabled]="searching"
        ></p-chips>
      </span>
    </div>
  </div>
</div>

<ng-template #loading>
  <boma-anim-spinning-loader [size]="30"> </boma-anim-spinning-loader>
</ng-template>

<p-overlayPanel
  #op
  appendTo="body"
  [showCloseIcon]="locationsLoaded"
  [style]="{ width: '450px', 'max-height': '600px' }"
>
  <ng-template pTemplate>
    <div class="flex mb-2">
      <button
        pButton
        label="Clear"
        class="p-button-text"
        (click)="clear()"
      ></button>

      <button
        *ngIf="totalExistingLocations && !loadedAll"
        pButton
        label="Load All"
        class="p-button-text p-button-secondary"
        (click)="loadAllLocations()"
        [disabled]="filterValue !== ''"
        [pTooltip]="
          filterValue === ''
            ? 'Load all locations at once'
            : 'Clear your filter to use this button'
        "
      ></button>

      <span class="p-input-icon-left ml-auto">
        <p-inputGroup>
          <p-inputGroupAddon class="mr-2">
            <ng-container *ngIf="!searching">
              Found:
              <p-badge
                [value]="paginationData.totalItems"
                severity="info"
              ></p-badge>
            </ng-container>
          </p-inputGroupAddon>
          <p-inputGroupAddon class="mr-2">
            <i
              [ngClass]="!searching ? 'pi pi-search' : 'pi pi-spin pi-spinner'"
            ></i>
          </p-inputGroupAddon>
          <input
            #inputField
            pInputText
            type="text"
            (input)="applyFilter()"
            [placeholder]="searching ? 'Searching...' : 'Search locations'"
            [(ngModel)]="filterValue"
            (keyup)="onFilterLocations($event.target.value)"
            [disabled]="!totalExistingLocations"
          />
        </p-inputGroup>
      </span>
    </div>

    <ng-container *ngIf="locationsLoaded; else loading">
      <div
        style="height: 360px; overflow-y: scroll"
        (scroll)="onTableScroll($event)"
      >
        <p-table
          #dt1
          [value]="locations"
          [selectionMode]="multipleLocations ? 'multiple' : 'single'"
          [(selection)]="selectedLocations"
          (onRowSelect)="onRowSelect($event)"
          (onRowUnselect)="onRowUnselect($event)"
          dataKey="id"
          [loading]="searching"
          [globalFilterFields]="['name', 'type']"
          loadingIcon="custom-boma-icon"
          [showLoader]="!this.loadedAll"
          [rows]="perPage"
        >
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 3rem" *ngIf="multipleLocations">
                <p-tableHeaderCheckbox
                  (click)="emitLocations()"
                ></p-tableHeaderCheckbox>
              </th>
              <th pSortableColumn="type" style="width: 3rem"></th>
              <th pSortableColumn="name">
                Location<p-sortIcon field="name"></p-sortIcon>
              </th>
            </tr>
            <!--
              TODO:THINK ABOUT HOW TO BEST DO THIS COMPONENT
              <tr>
              <th *ngIf="multipleLocations"></th>
              <th>
                <p-columnFilter
                  field="type"
                  matchMode="equals"
                  [showMenu]="false"
                >
                  <ng-template
                    pTemplate="filter"
                    let-value
                    let-filter="filterCallback"
                  >
                    <p-dropdown
                      [options]="locationTypeOptions"
                      (onChange)="filter($event.value.value)"
                      placeholder="Any"
                      [showClear]="true"
                      optionLabel="name"
                    >
                    </p-dropdown>
                  </ng-template>
                </p-columnFilter>
              </th>
              <th>
                <p-columnFilter type="text" field="name"></p-columnFilter>
              </th>
            </tr> -->
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr class="text-center">
              <td [attr.colspan]="multipleLocations ? 3 : 2">
                No records found for <strong>{{ this.query }}</strong
                >, please make sure you have the correct name.
              </td>
            </tr>
          </ng-template>
          <ng-template
            pTemplate="body"
            let-rowData
            let-location
            let-rowIndex="rowIndex"
          >
            <tr
              (click)="focusFilterField()"
              [pSelectableRow]="location"
              [pSelectableRowIndex]="rowIndex"
            >
              <td *ngIf="multipleLocations">
                <p-checkbox
                  [value]="location"
                  [ngModel]="selectedLocations"
                ></p-checkbox>
              </td>
              <td>
                <i
                  [class]="
                    location.type == 'Physical'
                      ? 'material-icons-round mi-place'
                      : 'material-icons-round mi-commute'
                  "
                  style="vertical-align: middle"
                ></i>
              </td>
              <td>{{ location.name }}</td>
            </tr>
          </ng-template>

          <ng-template pTemplate="summary">
            <div class="flex align-items-center justify-content-between">
              Loaded {{ locations?.length }} / {{ totalExistingLocations }} of
              the locations.
            </div>
          </ng-template>
        </p-table>
      </div>
    </ng-container>
  </ng-template>
</p-overlayPanel>
